import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editWithdraw, getBalance } from "../../redux/services/balanceSlice";
import Table from "../../common/Table";
import moment from "moment-timezone";
import { convertUtcToIst } from "../../common/TimeUtils";
import { exportToTablePDF } from "../../common/PdfFormat";
import { toast } from "react-toastify";

const Withdrawal = () => {
  const dispatch = useDispatch();
  const getBalanceData = useSelector((state) => state?.balance?.balanceData);
  const [filter, setFilter] = useState("false");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const getAllBalance = useCallback(async () => {
    try {
      await dispatch(
        getBalance({
          typeFilter: "withdraw",
          searchData,
          archiveFilter: filter,
        })
      );
    } catch (error) {}
  }, [dispatch, searchData, filter]);
  const filterOptions = [
    { value: "", label: "All" },
    { value: "true", label: "Settlement" },
    { value: "false", label: "UnSettlement" },
  ];
  
  useEffect(() => {
    getAllBalance();
  }, [getAllBalance]);

  const handleCheckboxChange = async (row) => {
    let payload = {
      balanceId: row._id,
      isArchive: !row.isArchive,
    };
    try {
      const response = await dispatch(editWithdraw(payload));
      if (response.payload.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        getAllBalance();
      }
    } catch (error) {
      console.error("Error updating withdraw status", error);
    }
  };
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      header: "Archive",
      key: "select",
      render: (_, row) => (
        <input
          type="checkbox"
          checked={row?.isArchive}
          className="w-5 h-5"
          onChange={() => handleCheckboxChange(row)}
        />
      ),
    },
    { header: "Name", key: "name" },
    {
      header: "Date",
      key: "updatedAt",
      render: (_, row) =>
        row.updatedAt
          ? moment(convertUtcToIst(row.updatedAt)).format("DD-MM-YYYY")
          : "-",
    },
    { header: "Type", key: "type" },
    { header: "Amount", key: "amount" },
  ];

  const exportToPDF = () => {
    const headersConfig = [
      {
        label: "S/N",
        key: "index",
        render: (_, __, index) => index + 1,
      },
      { label: "Name", key: "name" },
      {
        label: "Date",
        key: "updatedAt",
        render: (_, row) =>
          row.updatedAt
            ? moment(convertUtcToIst(row.updatedAt)).format("DD-MM-YYYY")
            : "-",
      },
      { label: "Type", key: "type" },
      { label: "Amount", key: "amount" },
    ];
    const data = getBalanceData?.balance_data || [];
    exportToTablePDF({
      tableName: "Withdrawal Data",
      data,
      headersConfig,
      pdfName: "withdrawal_data.pdf",
    });
  };

  return (
    <div>
      <Table
        title="Withdrawal"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        filterOptions={filterOptions}
        selectedFilter={filter}
        onFilterChange={(e) => setFilter(e ? e.value : "")}
        columns={columns}
        data={getBalanceData?.balance_data}
        exportButton={true}
        onExport={exportToPDF}
      />
    </div>
  );
};

export default Withdrawal;
